import { Component, input, effect, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { digitsOnlyDirective } from '../../directives/digits-only.directive';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { NgClass, DecimalPipe, CurrencyPipe, DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'unite-input-field',
    templateUrl: './input-field.component.html',
    styleUrls: ['./input-field.component.scss'],
    imports: [MatFormField, NgClass, MatIcon, MatInput, ReactiveFormsModule, digitsOnlyDirective, MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatDatepicker, DecimalPipe, CurrencyPipe, DatePipe]
})
export class InputFieldComponent {

  control = input<FormControl>();
  type = input<string>('text');
  classField = input('');
  editIcon = input(false);
  negative = input<boolean>(false);
  pattern = input<string>();
  max = input<number>(null);
  suffix = input<string>();

  suffixWithSpace: string;
  currentLang: string;


  constructor(private translate: TranslateService) {
    this.currentLang = this.translate.currentLang;

    // Update de variabele bij elke taalwissel
    this.translate.onLangChange.subscribe(event => {
      this.currentLang = event.lang;
    });

    effect(() => {
      const value = this.suffix();
      if (value && value.trim() !== '') {
        this.suffixWithSpace = ' ' + value;
      }
    });
  }


  onEnter(event: KeyboardEvent) {
    (<HTMLInputElement>event.target).blur();
  }

}
